import { React, useState, useEffect, } from 'react';
import PhotoPlaceholder from '../PagesClaude/placeholder';

const Home = ({ pages, setRoute, openLightbox }) => {

	const homeHeros = pages.find(p => p.slug === "home-hero-gallery");
	const heros = homeHeros.mediaNew;
	const homeLatest = pages.find(p => p.slug === "home-latest-gallery");
	const latest = homeLatest.mediaNew;
	const homeBottom = pages.find(p => p.slug === "home-bottom");

	const [idx, setIdx] = useState(0);
	const current = heros[idx] || {};


	useEffect(() => {
		window.scrollTo(0,0);
	}, []);

	useEffect(() => {
		const t = setInterval(() => setIdx((i) => (i + 1) % heros.length), 6000);
		return () => clearInterval(t);
	}, [heros.length]);
	


	return (
		<main className="wi-home">

			{/* Hero */}
			<section className="wi-hero">
				<div className="wi-hero-frame">
					{heros.map((p, i) => (
						<div
							key={p.id}
							className={`wi-hero-slide ${i === idx ? "is-on" : ""}`}
							aria-hidden={i !== idx}
						>
							<PhotoPlaceholder
								src={p.cdnUrl} 
								caption={p.title}
								ratio="16/10"
								index={i}
								showMeta={false}
								imgStyle={{objectFit: "cover", filter: 'none' }}
							/>
						</div>
					))}
					<button
						hidden
						className="wi-hero-open"
						onClick={() => openLightbox(current.id)}
						>
							<span className="wi-mono">View plate</span>
							<span aria-hidden>↗</span>
					</button>
				</div>
			
				<div className="wi-hero-side">
					<div className="wi-hero-eyebrow wi-mono">
						<span data-insert-html dangerouslySetInnerHTML={{__html: homeHeros.dataJson.country}}></span>
						{heros.length > 1 && <>
							&nbsp;{String(idx + 1).padStart(2, "0")} / {String(heros.length).padStart(2, "0")}
						</>}
					</div>

					<h1 className="wi-hero-title" data-insert-html dangerouslySetInnerHTML={{__html: homeHeros.subtitle}}></h1>
					<p className="wi-hero-lede" data-insert-html dangerouslySetInnerHTML={{__html: homeHeros.description}}></p>
					
					<div className="wi-hero-meta">
						<div>
							<div className="wi-mono wi-meta-k">Island</div>
							<div className="wi-meta-v">{current.pricingsJson?.name}</div>
						</div>
						<div>
							<div className="wi-mono wi-meta-k">Country</div>
							<div className="wi-meta-v">{current.pricingsJson?.info}</div>
						</div>
						{/*<div>
							<div className="wi-mono wi-meta-k">Made</div>
							<div className="wi-meta-v">{current.pricingsJson?.sku}</div>
						</div>*/}
					</div>
					
					<div className="wi-hero-actions">
						<button className="wi-btn" onClick={() => setRoute("shop")}>
							<span aria-hidden>→</span>
							Visit shop
						</button>
						<button hidden className="wi-btn-ghost" onClick={() => setRoute("gallery")}>
							Archive
						</button>
					</div>
					
					
					<div className="wi-hero-dots" hidden>
						{heros.map((_, i) => (
							<button
								key={i}
								className={`wi-dot-btn ${i === idx ? "is-on" : ""}`}
								onClick={() => setIdx(i)}
								aria-label={`Plate ${i + 1}`}
							/>
						))}
					</div>
				</div>
			</section>
			
			{latest.length > 0 && 
				<section className="wi-strip">
					<div className="wi-strip-head">
						<div className="wi-mono wi-eyebrow" data-insert-html dangerouslySetInnerHTML={{__html: homeLatest.dataJson.country}}></div>
						<h2 className="wi-strip-title">
						<span className="wi-italic">{homeLatest.subtitle}</span></h2>
						<p className="wi-strip-lede" data-insert-html dangerouslySetInnerHTML={{__html: homeLatest.description}}></p>
					</div>
					<div className="wi-strip-row">
						{latest.map((p, i) => (
							<button
								key={p.id}
								className="wi-strip-item"
								onClick={() => openLightbox(p.id, latest)}
							>
								<PhotoPlaceholder
									src={p.cdnUrl} 
									caption={p.pricingsJson.name}
									ratio={p.ratio}
									index={p.id.charCodeAt(4) + i}
									showMeta={false}
									imgStyle={{objectFit: "cover", filter: 'none' }}
								/>
								<div className="wi-strip-cap">
									<span>&nbsp; {p.pricingsJson.name}</span>
									<span className="wi-mono" hidden>{p.pricingsJson.info}</span>
								</div>
							</button>
						))}
					</div>
				</section>
			}
			
			{/* Editorial — statement */}
			<section className="wi-statement">
				<div className="wi-statement-rule">~</div>
					<div className="wi-statement-grid">
					<div className="wi-mono wi-eyebrow"  data-insert-html dangerouslySetInnerHTML={{__html: homeBottom.subtitle}}></div>
					<div>
						<p className="wi-statement-body" data-insert-html dangerouslySetInnerHTML={{__html: homeBottom.description}}></p>
						<button className="wi-link" onClick={() => setRoute("about")} data-insert-html dangerouslySetInnerHTML={{__html: homeBottom.dataJson.country}}></button>
					</div>
				</div>
			</section>
			
		</main>
	);
};

export default Home;
